import passport from './passport'
export const PASSPORTALLSTORE = {
  passport
}



// WEBPACK FOOTER //
// ./common/commonModule/passport/vuex/passportAllStore.js